import { OtpType, UseCase } from '@shopee-user/otp-hook-base-constants';

import {
  OtpParams,
  OtpConfig,
  CaptchaConfig,
} from '@shopee-user/otp-hook-base-types';

export enum TransitionEvent {
  ProceedToNext = 'ProceedToNext',
  BackToPrevious = 'BackToPrevious',
  ProceedToRequireOtp = 'ProceedToRequireOtp',
  ProceedToEnforceVoiceOtp = 'ProceedToEnforceVoiceOtp',
  ProceedToSelectOtpChannel = 'ProceedToSelectOtpChannel',
  ProceedToSelectOtpChannelInitial = 'ProceedToSelectOtpChannelInitial',
  Reset = 'Reset',
  ProceedToServiceUnavailable = 'ProceedToServiceUnavailable',
}

export enum InitialFlow {
  ShowCaptcha = 'ShowCaptcha',
  ShowConfirmationDialog = 'ShowConfirmationDialog',
  SelectOtpChannelInitial = 'SelectOtpChannelInitial',
  Default = 'Default',
  SkipSendOtp = 'SkipSendOtp',
  SwitchUsecase = 'SwitchUsecase',
}

export const DEFAULT_OTP_PARAMS: OtpParams = {
  encryptedAuthKey: '',
  authKey: '',
  token: '',
};

export const DEFAULT_OTP_CONFIG_PARTIAL: Omit<
  OtpConfig<unknown>,
  'type' | 'operation'
> = {
  availableChannels: [],
  hiddenChannels: [],
  preferredChannel: OtpType.Sms,
};

export const DEFAULT_CAPTCHA_CONFIG: CaptchaConfig = {
  captchaAppKey: '',
  captchaScene: '',
  captchaSignature: '',
};

export const OTP_TYPE_TO_USECASE: Record<OtpType, UseCase> = {
  [OtpType.Email]: UseCase.Otp,
  [OtpType.Sms]: UseCase.Otp,
  [OtpType.NoChannel]: UseCase.Otp,
  [OtpType.Viber]: UseCase.Otp,
  [OtpType.Voice]: UseCase.Otp,
  [OtpType.WhatsApp]: UseCase.Otp,
  [OtpType.Zalo]: UseCase.Otp,
  [OtpType.WhatsappAuthLink]: UseCase.WhatsappAuthLink,
};
